/* eslint-disable */
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';

const POST = 'POST';
const PATCH = 'PATCH';
const PUT = 'PUT';
const DELETE = 'DELETE';
const MODAL_TYPE_UPDATE = 'update';
const MODAL_TYPE_DELETE = 'delete';
const MODAL_TYPE_CONFIG = 'config';
const MODAL_TYPE_CALL = 'call';
const MODAL_TYPE_INFO = 'info';
const MODAL_TYPE_DELETE_CONFIRM = 'deleteConfirm';
const MODAL_TYPE_BOT_INSTALL = 'install';
const MODAL_TYPE_BOT_HIDE = 'hide';
const MODAL_TYPE_BOT_HIDE_OFF = 'hideoff';
const MODAL_TYPE_BOT_UNINSTALL = 'uninstall';
const MODAL_TYPE_ROBOT_SEARCH = 'robotsearch';
const MODAL_TYPE_MESSAGE_TRANSMIT = 'messageTransmit';
const MODAL_TYPE_MESSAGE_DELETE = 'messageDelete';
const MODAL_TYPE_GROUP_SEARCH = 'groupSearch';
const MODAL_TYPE_CALENDAR_UPDATE = 'calendarUpdate';
const MODAL_TYPE_CALENDAR_DELETE = 'calendarDelete';
const ROLE_ADMIN_NUMBER = '3211';
const SORT_NUMBER_ASC = (a, b) => (parseInt(a, 10) > parseInt(b, 10) ? 1 : -1);
const SORT_NUMBER_DESC = (a, b) => (parseInt(a, 10) > parseInt(b, 10) ? -1 : 1);
const SORT_STRING_ASC = (a, b) => {
  const na = a.toUpperCase();
  const nb = b.toUpperCase();
  if (na !== nb) {
    return na < nb ? -1 : 1;
  }
  return 0;
};
const SORT_STRING_DESC = (a, b) => {
  const na = a.toUpperCase();
  const nb = b.toUpperCase();
  if (na !== nb) {
    return na < nb ? 1 : -1;
  }
  return 0;
};
const SORT_BOOLEAN_DESC = (a, b) => {
  if (a === b) {
    return 0;
  }
  return a ? -1 : 1;
};
const SORT_BOOLEAN_ASC = (a, b) => {
  if (a === b) {
    return 0;
  }
  return a ? 1 : -1;
};
const GET_SORT = (type, sorting) => {
  if (type === 'number') {
    if (sorting === 'desc') {
      return SORT_NUMBER_DESC;
    }
    return SORT_NUMBER_ASC;
  }
  if (type === 'string') {
    if (sorting === 'desc') {
      return SORT_STRING_DESC;
    }
    return SORT_STRING_ASC;
  }
  if (type === 'boolean') {
    if (sorting === 'desc') {
      return SORT_BOOLEAN_DESC;
    }
    return SORT_BOOLEAN_ASC;
  }
  return null;
};
const STRING_BYTE_LENGTH = (string) =>
  string.replace(/[\0-\x7f]|([0-\u07ff]|(.))/g, '$&$1$2').length;
const INPUT_PROPERTIES_ALIAS = {
  label: '로봇 별칭',
  name: 'alias-text-input',
  placeholder: '로봇 별칭을 입력하세요.',
  maxLength: 15,
  // pattern: /([A-Za-z가-힣0-9.,\-_\s])/g,
};
const INPUT_PROPERTIES_SERIAL = {
  label: '로봇 시리얼',
  name: 'serial-text-input',
  placeholder: '로봇 시리얼을 입력하세요.',
  className: 'toUpperCase',
  // pattern: /([A-Za-z0-9]){8,}/g,
};
const INPUT_PROPERTIES_MANAGER_ID = {
  label: 'manager 아이디',
  name: 'managerId-text-input',
  placeholder: 'managerId를 입력하세요.',
  // pattern: /([A-Za-z0-9]){8,}/g,
};
const INPUT_PROPERTIES_SUBUSER_NAME = {
  label: '사용자 이름',
  isRequired: true,
  placeholder: '사용자 이름',
  pattern: /.{1,}$/g,
  error: '최소 한글자는 입력해야 합니다.',
};

const INPUT_PROPERTIES_SUBUSER_NICKNAME = {
  label: '사용자 닉네임',
  placeholder: '사용자 닉네임',
};
const REGISTER_ITEMS_LENGTH = 1;
const BOT_STATUS_HEADER_DATA = [
  // {
  //   name: 'checkbox',
  //   content: false,
  //   className: 'w-1',
  //   sorting: '',
  //   type: 'boolean',
  // },
  {
    name: 'title',
    content: '제목',
    sorting: '',
    type: 'string',
  },
  {
    name: 'category',
    content: '분류',
    sorting: '',
    type: 'string',
  },
  {
    name: 'installbutton',
    content: '',
    sorting: '',
    type: '',
  },
  {
    name: 'hidebutton',
    content: '',
    sorting: '',
    type: '',
  },
  {
    name: 'hideoffbutton',
    content: '',
    sorting: '',
    type: '',
  },
  {
    name: 'uninstallbutton',
    content: '',
    sorting: '',
    type: '',
  },
];
const ROBOT_STATUS_HEADER_DATA = [
  {
    name: 'number',
    content: '번호',
    sorting: '',
    type: 'string',
  },
  {
    name: 'serial',
    content: '시리얼',
    sorting: '',
    type: 'string',
  },
  {
    name: 'alias',
    content: '별칭',
    sorting: '',
    type: 'string',
  },
  {
    name: 'group',
    content: '그룹',
    sorting: '',
    type: 'string',
  },
  {
    name: 'user',
    content: '등록 사용자',
    sorting: '',
    type: 'number',
  },
  {
    name: 'bot',
    content: '설치 봇',
    sorting: '',
    type: 'number',
  },
  {
    name: 'button',
    content: '',
    sorting: '',
    type: '',
  },
  // {
  //   name: 'editbutton',
  //   content: '수정',
  //   sorting: '',
  //   type: '',
  // },
  // {
  //   name: 'configbutton',
  //   content: '설정',
  //   sorting: '',
  //   type: '',
  // },
  // {
  //   name: 'deletebutton',
  //   content: '',
  //   sorting: '',
  //   type: '',
  // },
];
const SUBUSER_STATUS_HEADER_DATA = [
  // {
  //   name: 'checkbox',
  //   content: false,
  //   className: 'w-1',
  //   sorting: '',
  //   type: 'boolean',
  // },
  {
    name: 'number',
    content: '번호',
    sorting: '',
    type: 'number',
  },
  // {
  //   name: 'image',
  //   content: '사진',
  //   sorting: '',
  //   type: 'string',
  // },
  {
    name: 'name',
    content: '이름',
    sorting: '',
    type: 'string',
  },
  {
    name: 'nickName',
    content: '닉네임',
    sorting: '',
    type: 'string',
  },
  {
    name: 'serial',
    content: '로봇 시리얼',
    sorting: '',
    type: 'string',
  },
  {
    name: 'alias',
    content: '로봇 별칭',
    sorting: '',
    type: 'string',
  },
  {
    name: 'group',
    content: '로봇 그룹',
    sorting: '',
    type: 'string',
  },
  {
    name: 'button',
    content: '',
    sorting: '',
    type: '',
  },
];
const MESSAGE_STATUS_HEADER_DATA = [
  // {
  //   name: 'checkbox',
  //   content: false,
  //   className: 'w-1',
  //   sorting: '',
  //   type: 'boolean',
  // },
  {
    name: 'value',
    content: '메시지 내용',
    sorting: '',
    type: 'string',
  },
  {
    name: 'serial',
    content: '로봇 시리얼',
    sorting: '',
    type: 'string',
  },
  {
    name: 'mode',
    content: '전달 방식',
    sorting: '',
    type: 'string',
  },
  {
    name: 'date',
    content: '보낸 일시',
    sorting: '',
    type: 'date',
  },
  {
    name: 'status',
    content: '전달 현황',
    sorting: '',
    type: 'number',
  },
  {
    name: 'buttons',
    content: '',
    sorting: '',
    type: '',
  },
];
const ROBOT_STATUS_VIEW_LIST_LENGTHS = [
  { value: 5, label: '5' },
  { value: 10, label: '10' },
  { value: 15, label: '15' },
  { value: 20, label: '20' },
];
const SUBUSER_STATUS_VIEW_LIST_LENGTHS = [
  { value: 5, label: '5' },
  { value: 10, label: '10' },
  { value: 15, label: '15' },
  { value: 20, label: '20' },
];
const BOT_STATUS_VIEW_LIST_LENGTHS = [
  { value: 15, label: '15' },
  { value: 20, label: '20' },
  { value: 25, label: '25' },
];
const MESSAGE_STATUS_VIEW_LIST_LENGTHS = [
  { value: 10, label: '10' },
  { value: 15, label: '15' },
  { value: 20, label: '20' },
];

const CAL_REGISTER_FIELD_TITLE = 'calTitle';
const CAL_REGISTER_FIELD_DATE = 'calDate';
const CAL_REGISTER_FIELD_TIMES = 'calTimes';
const CAL_REGISTER_FIELD_REPEAT = 'calRepeat';
const CAL_REGISTER_FIELD_WEEK = 'calWeek';
const CAL_REGISTER_FIELD_MONTHLY_DATEPICKER = 'calMonthlyDatepicker';
const CAL_REGISTER_FIELD_YEARLY_DATEPICKER = 'calYearlyDatepicker';
const CAL_REGISTER_FIELD_TIME = 'calTime';
const CAL_REGISTER_FIELD_CMD_TOGGLE = 'calCmdToggle';
const CAL_REGISTER_FIELD_CMD = 'calCmd';
const CAL_REGISTER_FIELD_GROUP_TOGGLE = 'calGroupToggle';
const CAL_REGISTER_FIELD_GROUP = 'calGroup';

const REPEATVALUE_DAY_OPTIONS = new Array(7).fill(false);
// const REPEATVALUE_DAY_OPTIONS = new Array(7).reduce((p, c) => {
//   const obj = { ...p, [c]: false };
//   return obj;
// }, {});

const REPEAT_OPTION_NONE = 'none';
const REPEAT_OPTION_WEEKLY = 'weekly';
const REPEAT_OPTION_MONTHLY = 'monthly';
const REPEAT_OPTION_YEARLY = 'yearly';

const REPEAT_OPTIONS = [
  {
    label: '한번',
    value: REPEAT_OPTION_NONE,
  },
  {
    label: '매주',
    value: REPEAT_OPTION_WEEKLY,
  },
  {
    label: '매월',
    value: REPEAT_OPTION_MONTHLY,
  },
  {
    label: '매년',
    value: REPEAT_OPTION_YEARLY,
  },
];

const REGISTER_TOGGLE_ALL = 'all';
const REGISTER_TOGGLE_GROUP_ALL = 'groupAll';
const REGISTER_TOGGLE_GROUP_SELECT = 'groupSelect';
const REGISTER_TOGGLE_ROBOT_SELECT = 'robotSelect';

const PHOTO_STATUS_VIEW_LIST_LENGTHS = [
  { label: 20, value: 20 },
  { label: 25, value: 25 },
  { label: 30, value: 30 },
];
const DIARY_STATUS_VIEW_LIST_LENGTHS = [
  { label: 10, value: 10 },
  { label: 15, value: 15 },
  { label: 20, value: 20 },
];

const TERMS_LIST = [
  { name: 'service', label: '서큘러스 이용약관', required: true },
  {
    name: 'privacy',
    label: '개인정보 수집 및 이용 약관',
    required: true,
  },
  { name: 'location', label: '위치정보 이용약관', required: false },
];

const LIST_FILTERS = [
  { label: '날짜', value: 'date' },
  { label: '시리얼', value: 'serial' },
  { label: '그룹', value: 'group' },
];
const LIST_SORTS = [
  { label: <ArrowDownwardIcon size="small" />, value: 'desc' },
  { label: <ArrowUpwardIcon size="small" />, value: 'asc' },
];

const FACE_DETECT_RESULTS = [
  '해당 사진에서 얼굴 인식 도중 에러가 발생하였습니다.',
  '',
  '해당 사진에서 얼굴을 인식할 수 없습니다. 다른 사진으로 다시 시도하시기 바랍니다.',
  '해당 사진으로 얼굴을 인식하기 어렵습니다. 인물이 가까이 찍힌 사진으로 다시 시도하시기 바랍니다.',
  '마스크를 착용한 사진은 인식할 수 없습니다. 다른 사진으로 다시 시도하시기 바랍니다.',
];

export {
  POST,
  PATCH,
  PUT,
  DELETE,
  SORT_NUMBER_ASC,
  SORT_NUMBER_DESC,
  SORT_STRING_ASC,
  SORT_STRING_DESC,
  GET_SORT,
  STRING_BYTE_LENGTH,
  INPUT_PROPERTIES_ALIAS,
  INPUT_PROPERTIES_SERIAL,
  INPUT_PROPERTIES_MANAGER_ID,
  INPUT_PROPERTIES_SUBUSER_NAME,
  INPUT_PROPERTIES_SUBUSER_NICKNAME,
  REGISTER_ITEMS_LENGTH,
  ROBOT_STATUS_HEADER_DATA,
  SUBUSER_STATUS_HEADER_DATA,
  MESSAGE_STATUS_HEADER_DATA,
  ROBOT_STATUS_VIEW_LIST_LENGTHS,
  SUBUSER_STATUS_VIEW_LIST_LENGTHS,
  BOT_STATUS_VIEW_LIST_LENGTHS,
  MESSAGE_STATUS_VIEW_LIST_LENGTHS,
  PHOTO_STATUS_VIEW_LIST_LENGTHS,
  DIARY_STATUS_VIEW_LIST_LENGTHS,
  MODAL_TYPE_UPDATE,
  MODAL_TYPE_DELETE,
  MODAL_TYPE_CONFIG,
  MODAL_TYPE_CALL,
  MODAL_TYPE_INFO,
  MODAL_TYPE_DELETE_CONFIRM,
  MODAL_TYPE_BOT_INSTALL,
  MODAL_TYPE_BOT_UNINSTALL,
  MODAL_TYPE_BOT_HIDE_OFF,
  MODAL_TYPE_BOT_HIDE,
  MODAL_TYPE_ROBOT_SEARCH,
  MODAL_TYPE_MESSAGE_TRANSMIT,
  MODAL_TYPE_MESSAGE_DELETE,
  BOT_STATUS_HEADER_DATA,
  MODAL_TYPE_GROUP_SEARCH,
  REPEAT_OPTION_NONE,
  REPEAT_OPTION_WEEKLY,
  REPEAT_OPTION_MONTHLY,
  REPEAT_OPTION_YEARLY,
  REPEAT_OPTIONS,
  REPEATVALUE_DAY_OPTIONS,
  CAL_REGISTER_FIELD_TITLE,
  CAL_REGISTER_FIELD_DATE,
  CAL_REGISTER_FIELD_TIMES,
  CAL_REGISTER_FIELD_REPEAT,
  CAL_REGISTER_FIELD_WEEK,
  CAL_REGISTER_FIELD_MONTHLY_DATEPICKER,
  CAL_REGISTER_FIELD_YEARLY_DATEPICKER,
  CAL_REGISTER_FIELD_TIME,
  CAL_REGISTER_FIELD_CMD_TOGGLE,
  CAL_REGISTER_FIELD_CMD,
  CAL_REGISTER_FIELD_GROUP_TOGGLE,
  CAL_REGISTER_FIELD_GROUP,
  REGISTER_TOGGLE_ALL,
  REGISTER_TOGGLE_GROUP_ALL,
  REGISTER_TOGGLE_GROUP_SELECT,
  REGISTER_TOGGLE_ROBOT_SELECT,
  MODAL_TYPE_CALENDAR_UPDATE,
  MODAL_TYPE_CALENDAR_DELETE,
  ROLE_ADMIN_NUMBER,
  TERMS_LIST,
  LIST_FILTERS,
  LIST_SORTS,
  FACE_DETECT_RESULTS,
};
